/* Landingpage „Volker Mehl × Miraherba" — das einzige eigene JavaScript.
 *
 * Zwei Aufgaben, keine Bibliothek:
 *   1. Die klebende Leiste blendet sich zwischen zwei Ankern ein.
 *   2. `aria-expanded` an den FAQ-Zusammenfassungen wird beim Auf- und
 *      Zuklappen nachgeführt. Ein fest ins Markup geschriebener Wert wäre nach
 *      dem ersten Klick falsch — schlimmer als keiner.
 *
 * Der Scroll-Hinweis der Fastenseite fehlt hier bewusst: Die Vergleichstabelle
 * hat nur zwei Produktspalten und passt auch auf ein Handy ohne Scrollen.
 *
 * Ohne diese Datei bleibt die Seite vollständig bedienbar; nur die Leiste fehlt.
 */
(() => {
  'use strict';

  /* 1. Klebende Leiste zwischen zwei Ankern
   *
   * Bewusst KEIN IntersectionObserver: Der meldet nur Zustandswechsel. Springt
   * man per Ankerlink über den Startanker hinweg — auf dieser Seite der
   * Regelfall —, kommt kein Ereignis und die Leiste bliebe aus. Ein auf den
   * Bildaufbau gedrosselter Scroll-Listener kennt jederzeit die Lage.
   */
  if (!customElements.get('volker-sticky-cta')) {
    customElements.define(
      'volker-sticky-cta',
      class VolkerStickyCta extends HTMLElement {
        connectedCallback() {
          this.start = document.getElementById(this.dataset.start || '');
          this.stop = document.getElementById(this.dataset.stop || '');
          if (!this.start) return;

          this.geplant = false;
          this.anstossen = this.anstossen.bind(this);
          window.addEventListener('scroll', this.anstossen, { passive: true });
          window.addEventListener('resize', this.anstossen, { passive: true });
          this.pruefen();
        }

        anstossen() {
          if (this.geplant) return;
          this.geplant = true;
          requestAnimationFrame(() => {
            this.geplant = false;
            this.pruefen();
          });
        }

        pruefen() {
          const hoehe = window.innerHeight;
          const startErreicht = this.start.getBoundingClientRect().top <= hoehe * 0.85;
          const stopErreicht = this.stop ? this.stop.getBoundingClientRect().top <= hoehe * 0.9 : false;
          this.setze(startErreicht && !stopErreicht);
        }

        setze(zeigen) {
          if (zeigen === this.zustand) return;
          this.zustand = zeigen;
          if (zeigen) {
            this.hidden = false;
            // Erst im nächsten Bild einblenden, sonst greift der Übergang nicht.
            requestAnimationFrame(() => this.classList.add('is-visible'));
          } else {
            this.classList.remove('is-visible');
          }
        }

        disconnectedCallback() {
          window.removeEventListener('scroll', this.anstossen);
          window.removeEventListener('resize', this.anstossen);
        }
      }
    );
  }

  /* 2. aria-expanded an den FAQ-Einträgen nachführen */
  document.querySelectorAll('.volker-faq .accordion-details').forEach((details) => {
    const summary = details.querySelector('summary');
    if (!summary) return;
    const setze = () => summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
    setze();
    details.addEventListener('toggle', setze);
  });
})();
